import NoCharacter from "components/no-character/NoCharacter";
import manager from "managers/app";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import { ViewArmourElementalOverallProps } from "views/relics/armour/elemental/overall/types";
import "./ArmourElementalOverall.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
	};
};

class ArmourElementalOverall extends Component<ViewArmourElementalOverallProps> {
	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		return (
			<div id="armour-elemental-overall" className="relic">
				<h1 style={{ textAlign: "center" }}>{t.t("Coming Soon!")}</h1>
				{/* <h1>{t.t("Overall")}</h1>
				<div className="options">
					<ContentOptions jobs={jobLists.relic[RelicGroup.ARMOUR_ELEMENTAL]} relic={RelicGroup.ARMOUR_ELEMENTAL} />
				</div>
				<OverallTable relicType={RelicType.ARMOUR} relic={RelicGroup.ARMOUR_ELEMENTAL} /> */}
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

}
export default connect(mapStateToProps)(ArmourElementalOverall);
